export default "public/loader-big.gif";